export function HarriIQFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/harriIQ-filled.svg'"></ng-include>`
    }
}